<template>
  <v-input
    :value="value"
    :rules="$rules('app.required', 'app.arrays.notEmpty')"
  >
    <template v-slot:append>
      <slot name="edit"></slot>
    </template>
    <v-list v-if="list.length !== 0">
      <v-list-item v-for="(item, i) in list" :key="i" class="pl-0" dense>
        <v-list-item-content> {{ i + 1 }}. {{ item }} </v-list-item-content>
      </v-list-item>
    </v-list>
    <span v-else>{{ $t("app.forms.no-data") }}</span>
  </v-input>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    list: []
  }),

  watch: {
    value: function(val) {
      this.list = val;
    }
  },

  mounted: function() {
    this.$nextTick(async function() {
      this.list = this.value;
    });
  }
};
</script>

<style lang="scss" scoped>
.v-list {
  max-height: 200px;
  overflow-y: auto;
}
</style>
